var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsString, IsUUID } from 'class-validator';
import { EmbedKeyStatus } from '../enums/embed-key-status.enum.js';
/**
 * Read shape for one embed key shown in the office-location settings foldout.
 * The `publishableKey` is safe to echo repeatedly — it is a *publishable*
 * credential, meaningless without a listed origin, unlike the signed session
 * token which is minted at exchange time and never persisted.
 */
export class EmbedKeyResponseDto {
    id;
    officeLocationId;
    publishableKey;
    allowedOrigins;
    status;
    revokedAt;
    lastUsedAt;
    isActive;
    createdAt;
    updatedAt;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], EmbedKeyResponseDto.prototype, "id", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], EmbedKeyResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], EmbedKeyResponseDto.prototype, "publishableKey", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    Expose(),
    __metadata("design:type", Array)
], EmbedKeyResponseDto.prototype, "allowedOrigins", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmbedKeyResponseDto.prototype, "status", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], EmbedKeyResponseDto.prototype, "revokedAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], EmbedKeyResponseDto.prototype, "lastUsedAt", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], EmbedKeyResponseDto.prototype, "isActive", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", String)
], EmbedKeyResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], EmbedKeyResponseDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=embed-key.response.dto.js.map